import styled from 'styled-components';

export const ServicesContainer = styled.div`
  height: 550px;
  display: flex;
  flex-direction: column;
  background: #010606;
  overflow:hidden !important;

  @media screen and (max-width: 768px) {
    height: 1250px;
  }

  @media screen and (max-width: 480px) {
    height: 1300px;
  }
`;

export const ServicesWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Three cards per row */
  grid-template-rows: auto auto; /* Two rows */
  gap: 16px;
  padding: 0 50px;
  scroll-snap-type: x mandatory;
  scroll-padding: 16px; /* Add space between cards in scrollable area */

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr; /* Single column */
    grid-template-rows: repeat(auto-fit, minmax(200px, 1fr)); /* Adjust the height as needed */
    justify-items: center;
    padding: 0 20px;
    scroll-snap-align: start;
  }
`;

export const ServicesCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const ServicesIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
`;

export const CardFront = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const CardBack = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  text-align: center;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
`;

export const FeaturedH1 = styled.h1`
  font-size: 2.5rem;
  color: #fff;
  padding: 10vh;
  margin-bottom: 64px;
  align-items: center;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const FeaturedH2 = styled.h2`
font-size: 1.5rem;
color: #fff;
padding: 6vh;
margin-bottom: 32px;
align-items: center;
text-align: center;

@media screen and (max-width: 480px) {
  font-size: 2rem;
}
`;

export const ServicesP = styled.p`
  font-size: 0.8rem;
  text-align: justify;
`;
